module.exports = __webpack_public_path__ + "img/9.8bfc4c0c.jpg";